import Typography from "@mui/material/Typography"
import React from "react"
import Box from "@mui/material/Box"

export const StatCard = ({ icon, label, value, focus = true, sx }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: {
        xs: "column",
        lg: "row",
      },
      alignItems: "center",
      textAlign: {
        xs: "center",
        md: "left",
      },
      gap: 1.5,
      px: {
        xs: 0,
        md: 3,
      },
      py: 1.8,
      color: "#999",
      ...sx,
    }}
  >
    <Box
      sx={{
        display: "flex",
        color: focus ? "#c49654" : "#999",
        "& svg": {
          fontSize: {
            xs: 40,
            md: 50,
          },
          strokeWidth: 1,
        },
      }}
    >
      {icon}
    </Box>

    <Box>
      <Typography
        sx={{
          fontWeight: 800,
          mb: 1,
          fontSize: 13,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          mt: 0.5,
          fontSize: {
            xs: 18,
            md: 22,
          },
          overflowWrap: "normal",
          wordBreak: "normal",
          maxWidth: {
            xs: 70,
            md: "100%",
          },
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: {
            xs: "normal",
            md: "nowrap",
          },
          fontWeight: 900,
          lineHeight: 1.1,
          color: focus ? "#c49654" : "#eee",
        }}
      >
        {value}
      </Typography>
    </Box>
  </Box>
)
